var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("退货标准及周期？")]),_c('div',{staticClass:"content-info"},[_c('p',{staticClass:"txt1"},[_vm._v("\n      非生鲜类（米面粮油、调料干货、厨房用品等）支持7天无理由退货；\n      "),_c('br'),_vm._v("生鲜类（蔬菜水果、鲜肉蛋禽、海鲜水产、冷藏或冻货、面点等）支持18小时质量问题退货。\n    ")])])])
}]

export { render, staticRenderFns }